<script setup lang="ts">
import type { HTMLAttributes } from "vue";
import { Primitive, type PrimitiveProps } from "radix-vue";
import { type ButtonVariants, buttonVariants } from ".";
import { cn } from "../../utils";
import Icon from "../../Icon.vue";

interface Props extends PrimitiveProps {
  variant?: ButtonVariants["variant"];
  size?: ButtonVariants["size"];
  as?: string;
  class?: HTMLAttributes["class"];
  prependIcon?: string;
}

const props = withDefaults(defineProps<Props>(), {
  as: "button",
});
</script>

<template>
  <Primitive
    :as="as"
    :as-child="asChild"
    :class="cn(buttonVariants({ variant, size }), props.class)"
    class="flex items-center"
  >
    <Icon v-if="prependIcon" :name="prependIcon" class="mr-2 h-6 w-6" />
    <slot />
  </Primitive>
</template>
